import React from "react";

function Resume() {
  return (
    <>
      <div className="container">
        <div className="tokyo_tm_contact">
          <div className="tokyo_tm_title">
            <div className="title_flex">
              <div className="left">
                <span>My Resume</span>
                <h3>Take A Copy For Later</h3>
              </div>
            </div>
          </div>

          <iframe
            src="/assets/Scott_Ankiewicz_resume.pdf"
            title="Scott's Resume"
            style={{
              border: "none",
            }}
            width="100%"
            height="1000px"
          ></iframe>
          {/* <embed
            name="Scott's Resume"
            style="position:absolute; left: 0; top: 0;"
            width="100%"
            height="1000px"
            src="/assets/Scott_Ankiewicz_resume.pdf"
            type="application/pdf"
            // internalid="DAEB6B4A90D2FD6B2DD1AF71C20C0AB6"
          ></embed> */}
        </div>
      </div>
      {/* END COTACT */}
    </>
  );
}

export default Resume;
